import * as Yup from 'yup';
import { cpfValidator } from '../../../utils/CpfValidator';

export const PasswordRecoveryOtherUnimedValidation = Yup.object().shape({
  numeroCartao: Yup.string().required('Insira um cartão válido e correto'),
  dataNascimento: Yup.string().required('Insira uma Data de Nascimento válida e e correta'),
  cpf: Yup.string().test('cpf-valid', 'Insira um CPF válido e correto', function (value) {
    return cpfValidator(value || '');
  }).required('Insira um CPF válido e correto'),
})
